export const dialogPt = {
  header: {
    class:
      "flex items-center justify-between shrink-0 p-4 rounded-tl-lg rounded-tr-lg bg-teal-light font-bold !text-university-primary",
  },
};
